import React, { useState } from "react";

const Support = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Support Request Submitted:", formData);
    // Add functionality to send this data to your backend or support system
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="flex flex-col items-center p-6 bg-gray-100 min-h-screen">
      <div className="max-w-4xl w-full bg-white shadow-md rounded-lg p-8">
        {/* Header */}
        <h1 className="text-3xl font-bold text-center mb-6 text-blue-600">
          Support Center
        </h1>
        <p className="text-center text-gray-700 mb-8">
          Need help? Contact us for all your logistics needs!
        </p>

        {/* Support Options */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
          <div className="flex items-center gap-4 p-4 bg-blue-50 border border-blue-300 rounded-lg">
            <i className="fas fa-envelope text-blue-500 text-2xl"></i>
            <div>
              <p className="font-semibold text-blue-700">Email Us</p>
              <p className="text-gray-600">support@logistics.com</p>
            </div>
          </div>
          <div className="flex items-center gap-4 p-4 bg-green-50 border border-green-300 rounded-lg">
            <i className="fas fa-phone text-green-500 text-2xl"></i>
            <div>
              <p className="font-semibold text-green-700">Call Us</p>
              <p className="text-gray-600">+1 (800) 123-4567</p>
            </div>
          </div>
          <div className="flex items-center gap-4 p-4 bg-yellow-50 border border-yellow-300 rounded-lg sm:col-span-2">
            <i className="fas fa-question-circle text-yellow-500 text-2xl"></i>
            <div>
              <p className="font-semibold text-yellow-700">FAQs</p>
              <p className="text-gray-600">Find answers to common questions.</p>
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Send Us a Message
          </h2>
          <div>
            <label
              htmlFor="name"
              className="block text-gray-700 font-medium mb-2"
            >
              Your Name
            </label>
            <input
              type="text"
              name="name"
              id="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
            />
          </div>
          <div>
            <label
              htmlFor="email"
              className="block text-gray-700 font-medium mb-2"
            >
              Email Address
            </label>
            <input
              type="email"
              name="email"
              id="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
            />
          </div>
          <div>
            <label
              htmlFor="message"
              className="block text-gray-700 font-medium mb-2"
            >
              Message
            </label>
            <textarea
              name="message"
              id="message"
              rows="4"
              value={formData.message}
              onChange={handleInputChange}
              required
              className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
            ></textarea>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white font-medium py-3 rounded-lg hover:bg-blue-700 transition"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Support;
